import React, { useState } from 'react'
import styled from 'styled-components'
import { usePatientContext } from '@/v2/contexts/PatientContext'
import InsurancesTabMobile from './InsurancesTabMobile'
import EligibilitiesTabMobile from './EligibilitiesTabMobile'
import ClaimsTabMobile from './ClaimsTabMobile'

const Wrapper = styled.div`
  padding: 0;
  background: #fff;
  min-height: 100%;
  overflow-x: hidden;
`

const TabsContainer = styled.div`
  background: #f8f9fa;
  padding: 12px 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`

const TabsList = styled.div`
  display: flex;
  gap: 8px;
  min-width: min-content;
`

const Tab = styled.button`
  background: ${({ active }) => (active ? '#1976d2' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#666')};
  border: ${({ active }) => (active ? 'none' : '1px solid #e0e0e0')};
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: ${({ active }) =>
    active ? '0 2px 4px rgba(25, 118, 210, 0.2)' : 'none'};

  &:active {
    transform: scale(0.97);
  }
`

const Content = styled.div`
  padding: 16px;
  background: #fff;
  overflow-x: hidden;
`

const InsuranceMobile = () => {
  const { patient } = usePatientContext()
  const [tab, setTab] = useState('insurances')

  if (!patient?.id) return null

  const tabsComponents = {
    insurances: (
      <InsurancesTabMobile
        onEligibilityCheckClick={() => setTab('eligibilities')}
      />
    ),
    eligibilities: (
      <EligibilitiesTabMobile onClaimClick={() => setTab('claims')} />
    ),
    claims: <ClaimsTabMobile />,
  }

  return (
    <Wrapper>
      <TabsContainer>
        <TabsList>
          <Tab
            active={tab === 'insurances'}
            onClick={() => setTab('insurances')}
          >
            Insurances
          </Tab>
          <Tab
            active={tab === 'eligibilities'}
            onClick={() => setTab('eligibilities')}
          >
            Eligibilities
          </Tab>
          <Tab active={tab === 'claims'} onClick={() => setTab('claims')}>
            Claims
          </Tab>
        </TabsList>
      </TabsContainer>
      <Content>{tabsComponents[tab]}</Content>
    </Wrapper>
  )
}

export default InsuranceMobile
